/* Elora Family Necklace — couleur + nombre de pierres (2 à 6) + une pierre par emplacement.
   Dérivé de svl-elora-config.js (qu'on ne touche pas : il sert le collier et le bracelet). */
(() => {
  const L_ = window.SVL_I18N || {};
  const V_ = (x) => (L_.vals && L_.vals[x]) || x;
  const pad = (i) => String(Number(i) + 1).padStart(2, "0");
  const MONTHS = (L_.months && L_.months.length === 12) ? L_.months : ["January","February","March","April","May","June","July","August","September","October","November","December"];
  // 🔴 le symbole vient du marche, jamais d'un "$" en dur : on relit le format que
  // Liquid a deja rendu dans le DOM (prefixe, suffixe et separateur decimal).
  const FMT = (() => {
    let f = null;
    return () => {
      if (f) return f;
      const el = document.querySelector("[data-svf-price], [data-svf-compare]");
      const t = (el && el.textContent.trim()) || "";
      const m = t.match(/^(\D*)[\d.,\s\u00a0]+(\D*)$/);
      f = m ? { pre: m[1], post: m[2], dec: /\d,\d{2}$/.test(t) ? "," : "." }
            : { pre: "$", post: "", dec: "." };
      return f;
    };
  })();
  const money = (cents) => {
    const f = FMT();
    const n = cents % 100 ? (cents / 100).toFixed(2) : String(cents / 100);
    return f.pre + (f.dec === "," ? n.replace(".", ",") : n) + f.post;
  };

  document.querySelectorAll("[data-svf]").forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = "true";

    const config = JSON.parse(root.querySelector("[data-config]").textContent);
    const t = config.strings;
    const form = root.querySelector("form");
    const button = root.querySelector("[data-submit]");
    const error = root.querySelector("[data-error]");
    const slots = [...root.querySelectorAll("[data-slot]")];
    let color = "Gold";
    let count = 2;
    let busy = false;
    const pickers = [];

    const closePickers = () => pickers.forEach((p) => { p.menu.hidden = true; p.trigger.setAttribute("aria-expanded", "false"); });

    /* ---------- listes déroulantes maison, avec la vignette de la pierre ---------- */
    root.querySelectorAll("select").forEach((select, index) => {
      const picker = document.createElement("div");
      picker.className = "svb-stone-picker";
      picker.dataset.bundlePicker = "";

      const trigger = document.createElement("button");
      trigger.type = "button";
      trigger.className = "svb-stone-picker__button";
      trigger.setAttribute("aria-haspopup", "listbox");
      trigger.setAttribute("aria-expanded", "false");
      const label = select.closest("label").querySelector(".svb__label");
      label.id = root.id + "-label-" + index;
      trigger.setAttribute("aria-labelledby", label.id + " " + root.id + "-value-" + index);

      const preview = document.createElement("img");
      preview.alt = ""; preview.hidden = true; preview.width = 24; preview.height = 24;
      const value = document.createElement("span");
      value.className = "svb-stone-picker__value";
      value.id = root.id + "-value-" + index;
      const caret = document.createElement("span");
      caret.className = "svb-stone-picker__caret";
      caret.setAttribute("aria-hidden", "true");
      trigger.append(preview, value, caret);

      const menu = document.createElement("div");
      menu.className = "svb-stone-picker__menu";
      menu.setAttribute("role", "listbox");
      menu.setAttribute("aria-labelledby", label.id);
      menu.hidden = true;

      const choices = [];
      [...select.options].filter((o) => o.value !== "").forEach((option) => {
        const choice = document.createElement("button");
        choice.type = "button";
        choice.className = "svb-stone-picker__option";
        choice.setAttribute("role", "option");
        option.dataset.image = config.stones[Number(option.value)];
        const img = document.createElement("img");
        img.src = option.dataset.image; img.alt = ""; img.width = 32; img.height = 32; img.loading = "lazy";
        const text = document.createElement("span");
        text.textContent = option.textContent;
        choice.append(img, text);
        menu.append(choice);
        choices.push({ choice, option });
        choice.addEventListener("click", () => {
          if (busy) return;
          select.value = option.value;
          select.dispatchEvent(new Event("change", { bubbles: true }));
          closePickers();
          trigger.focus();
        });
      });

      const update = () => {
        const selected = select.selectedOptions[0];
        value.textContent = selected ? selected.textContent : "";
        preview.hidden = !(selected && selected.dataset.image);
        if (!preview.hidden) preview.src = selected.dataset.image;
        trigger.disabled = busy;
        choices.forEach(({ choice, option }) => choice.setAttribute("aria-selected", String(option.value === select.value)));
      };

      trigger.addEventListener("click", () => {
        const open = menu.hidden;
        closePickers();
        menu.hidden = !open;
        trigger.setAttribute("aria-expanded", String(open));
      });
      picker.addEventListener("keydown", (event) => {
        const list = choices.map((c) => c.choice);
        if (event.key === "Escape") { event.preventDefault(); closePickers(); trigger.focus(); }
        else if (["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) {
          event.preventDefault();
          menu.hidden = false; trigger.setAttribute("aria-expanded", "true");
          const i = list.indexOf(document.activeElement);
          const next = event.key === "Home" ? 0 : event.key === "End" ? list.length - 1
            : event.key === "ArrowDown" ? (i + 1) % list.length : i <= 0 ? list.length - 1 : i - 1;
          list[next].focus();
        }
      });
      picker.addEventListener("focusout", (event) => {
        if (!picker.contains(event.relatedTarget)) { menu.hidden = true; trigger.setAttribute("aria-expanded", "false"); }
      });

      picker.append(trigger, menu);
      select.after(picker);
      select.hidden = true;
      select.tabIndex = -1;
      select.setAttribute("aria-hidden", "true");
      select.addEventListener("change", update);
      pickers.push({ trigger, menu, update });
      update();
    });
    document.addEventListener("click", (event) => { if (!event.target.closest("[data-bundle-picker]")) closePickers(); });

    /* ---------- état ---------- */
    const variant = () => config.variants.find((v) => v.option1 === color && v.option2 === count + " birthstones");
    const chosen = () => slots.slice(0, count).map((s) => s.querySelector("select").value);

    /* le prix de la buy-box suit le nombre de pierres */
    const renderPrice = (v) => {
      document.querySelectorAll("[data-svf-price]").forEach((el) => { el.textContent = money(v.price); });
      document.querySelectorAll("[data-svf-compare]").forEach((el) => { el.textContent = v.compare ? money(v.compare) : ""; });
    };

    /* l'aperçu : les pierres choisies, côte à côte, comme sur le pendentif */
    const renderPreview = () => {
      const body = root.querySelector("[data-preview-body]");
      body.style.setProperty("--n", count);
      body.innerHTML = chosen().map((m) =>
        '<span class="svf__stone"><img src="' + config.stones[Number(m)] + '" alt="" width="40" height="40"><span>' +
        MONTHS[Number(m)].slice(0, 3) + "</span></span>").join("");
    };

    const sync = () => {
      root.querySelectorAll("[data-count]").forEach((b) => {
        b.setAttribute("aria-pressed", String(Number(b.dataset.count) === count));
        b.disabled = busy;
      });
      root.querySelectorAll("[data-color]").forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.color === color)));
      root.querySelector("[data-color-label]").textContent = V_(color);
      root.querySelector("[data-count-label]").textContent = (L_.stonesN || "{n} birthstones").replace("{n}", count);
      slots.forEach((s, i) => { s.hidden = i >= count; });
      const v = variant();
      const note = root.querySelector("[data-availability]");
      note.hidden = !v || v.available;
      note.textContent = t.unavailable;
      if (v) renderPrice(v);
      renderPreview();
      button.disabled = busy;
      button.textContent = busy ? t.busy : t.add;
      pickers.forEach((p) => p.update());
    };

    root.querySelectorAll("[data-count]").forEach((b) => b.addEventListener("click", () => {
      if (busy) return;
      count = Number(b.dataset.count);
      error.hidden = true;
      sync();
    }));

    /* la galerie du thème suit la couleur */
    const showMedia = () => {
      const v = variant();
      if (!v || !v.mediaId) return;
      const item = document.querySelector('[data-target$="-' + v.mediaId + '"]');
      if (!item) return;
      (item.querySelector("button, a, [role=button]") || item).click();
    };

    root.querySelectorAll("[data-color]").forEach((b) => b.addEventListener("click", () => {
      if (busy) return;
      color = b.dataset.color;
      sync();
      showMedia();
    }));
    root.querySelectorAll("select").forEach((s) => s.addEventListener("change", () => { error.hidden = true; sync(); }));

    /* ---------- ajout au panier → tiroir Revive (LuminTheme) ---------- */
    const refreshDrawer = async (data) => {
      const drawer = document.querySelector("cart-drawer");
      if (!drawer || typeof drawer.renderContents !== "function") {
        window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : "/cart";
        return;
      }
      const ids = drawer.getSectionsToRender().map((s) => s.id);
      if (!data.sections || ids.some((id) => !data.sections[id])) {
        const r = await fetch(`${window.location.pathname}?sections=${ids.join(",")}`);
        data = { sections: await r.json() };
      }
      drawer.classList.remove("is-empty");
      drawer.renderContents(data);
      drawer.open();
      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        const cart = await fetch((window.routes ? window.routes.cart_url : "/cart") + ".js").then((r) => r.json());
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "efam-config", cartData: cart });
      }
    };

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (busy) return;
      error.hidden = true;
      const v = variant();
      if (!v || !v.available) { error.textContent = t.unavailable; error.hidden = false; return; }

      const stones = chosen();
      const properties = {};
      stones.forEach((m, i) => { properties[(L_.propStone || "Birthstone") + " " + (i + 1)] = MONTHS[Number(m)]; });
      // code atelier, masqué au client par le préfixe _
      properties._stone_ref = stones.map(pad).join(" / ");

      busy = true;
      sync();
      try {
        const drawer = document.querySelector("cart-drawer");
        const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];
        const response = await fetch((window.routes ? window.routes.cart_add_url : "/cart/add") + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties }], sections, sections_url: window.location.pathname })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || t.error);
        await refreshDrawer(data);
      } catch (e) {
        error.textContent = e.message || t.error;
        error.hidden = false;
      } finally {
        busy = false;
        sync();
      }
    });

    sync();
  });
})();
